import { useRef, useEffect, useState } from 'react';

interface EditableDecimalInputProps {
    children?: React.ReactNode;
    editable:boolean;
    value:number;
    inputDivClassName?:string;
    inputClassName?:string;
    inputTextBefore?: string;
    inputTextAfter?: string;
    spanDivClassName?:string;
    spanClassName?:string;
    spanTextBefore?: string;   
    spanTextAfter?: string;   
    onEditStart : () => void,
    onEditEnd : () => void,
    onValueChanged : (v:number) => void;
}

function EditableDecimalInput(props:EditableDecimalInputProps) { 
  const [isEditing, setIsEditing] = useState(false);
  const internalRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditing && internalRef.current) {
      internalRef.current.focus();
    }
  }, [isEditing]);

  const handleEdit = () => {
    if(props.editable) {
        setIsEditing(true);
        props.onEditStart();
    }
  };

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if(event.key == 'Enter') {
      try {
        let v = (internalRef.current?.value || 'error').replace(',','.');
        let newVal = parseFloat(v);       
        if(!isNaN(newVal)) {
            props.onValueChanged(newVal);
        }
      } catch (err) {      
      }
      setIsEditing(false);
      props.onEditEnd();
    }
  }

  function handleBlur(event: React.ChangeEvent<HTMLInputElement>) {
    try {
      let v = (internalRef.current?.value || 'error').replace(',','.');
      let newVal = parseFloat(v);      
        if(!isNaN(newVal)) {
            props.onValueChanged(newVal);
        }
    } catch (err) {      
    }
    setIsEditing(false);
    props.onEditEnd();
  };

  return isEditing ? (
    <div className={props.inputDivClassName}>
      {props.inputTextBefore!=null ? <span style={{marginRight: '3px'}}>{props.inputTextBefore}</span> : null}
      <input className={props.inputClassName} ref={internalRef} 
              onBlur={handleBlur} 
              onKeyDown={handleKeyDown}              
              defaultValue={props.value} />
      {props.inputTextAfter!=null ? <span style={{marginLeft: '3px'}}>{props.inputTextAfter}</span> : null}
    </div>
  ) : (
    <div className={props.spanDivClassName} onClick={handleEdit} style={props.editable?{cursor: 'pointer'}:{}}>      
      {props.spanTextBefore!=null ? <span style={{marginRight: '3px'}}>{props.spanTextBefore}</span> : null}
      <span className={props.spanClassName} >{props.value}</span>
      {props.spanTextAfter!=null ? <span style={{marginLeft: '3px'}}>{props.spanTextAfter}</span> : null}
    </div>
  );
}

export default EditableDecimalInput;